import React from "react";

export function TabContentWrapper({ minHeight = "800px", children }) {
  return (<div style={{ minHeight }}>{children}</div>);
}
